import { Stack, styled, Typography } from '@mui/material';

export const PageTitle = styled('h1')`
  font-size: 28px;
  font-weight: 600;
  color: #10253E;
  text-align: center;
  margin: 0 auto;
`;

export const FormContainer = styled('div')`
  max-width: 650px;
  padding: 30px 20px;
  margin: 5px auto;
  border: 1px solid #F7FCF9;
  border-radius: 20px;
  box-shadow: #070D531A 0px 0px 20px;
`;

export const SingleLineFormItemWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormItemContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '1')};
  flex-basis: ${({ flexBasis }) => (flexBasis ? flexBasis : '100%')};
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
  padding-right: ${({ paddingRight }) => (paddingRight ? paddingRight : '0px')};
`;

export const ResultContainer = styled(Stack)`
  border-radius: 12px;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 100px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  align-items: center;
`;

export const ResultContainerContent = styled(Stack)`
  gap: 20px;
  width: 100%;
  align-items: center;
`;

export const Instruction = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  width: 60%;
  text-align: center;
  text-wrap: pretty;
`;
